// ./src/services/apis/apiGoogleMaps.ts
import axios from 'axios';

import auth from '@config/auth';
import { ConfigBase } from '@config/index';

const apiTraccarRebox = axios.create({
  baseURL: ConfigBase.traccar.rebox.baseUrl,
  auth: {
    username: auth.traccar.rebox.username,
    password: auth.traccar.rebox.password,
  },
});

export default apiTraccarRebox;
